import image1_1 from '../assets/image1_1.png';
import image2_1 from '../assets/image2_1.png';
import image3_1 from '../assets/image3_1.png';

export const employmentData = [
  {
    id: 1,
    image: image3_1,
    title: 'Software Engineer Intern',
    company: 'PhilanthPro',
    date: 'Jan - Apr 2026',
    description: 'I developed a full-stack web application in a collaborative Agile team environment, improving system reliability by addressing technical debt, resolving bugs, and delivering new features including an AI-powered portfolio insights tool.',
    link: 'https://www.philanthpro.com',
    tags: [
      { label: 'React', color: 'hsl(200, 100%, 40%)' },
      { label: 'TypeScript', color: 'hsl(50, 100%, 40%)' },
      { label: 'NestJS', color: 'hsl(0, 100%, 40%)' },
      { label: 'Prisma', color: 'hsl(280, 100%, 40%)' },
      { label: 'PostreSQL', color: 'hsl(240, 100%, 40%)' },
      { label: 'Jest', color: 'hsl(342.76, 39.73%, 42.94%)' },

    ],
  },
  {
    id: 2,
    image: image2_1,
    title: 'Energy Audit Intern',
    company: 'SCCSA',
    date: 'May - Aug 2025',
    description: 'I built a full-stack web application to visualize and demonstrate energy systems in buildings, making complex energy flows accessible and understandable to everyone.',
    link: 'https://www.suncoastsolar.org',
    tags: [
      { label: 'JavaScript', color: 'hsl(50, 100%, 40%)' },
      { label: 'Flask', color: 'hsl(0, 100%, 40%)' },
      { label: 'Python', color: 'hsl(75, 100%, 40%)' },
      { label: 'SQLite', color: 'hsl(240, 100%, 40%)' },
      { label: 'PlatformIO', color: 'hsl(34, 100%, 40%)' },
      { label: 'C++', color: 'hsl(240, 100%, 20%)' },
    ],
  },
  {
    id: 1,
    image: image1_1,
    title: 'Help Desk & System Admin',
    company: 'ACD Systems',
    date: 'Jan - Sep 2023',
    description: 'I developed and maintained internal automation tools to improve monitoring reliability, while collaborating with DevOps and engineering teams on deployments, integrations, and secure system operations across multiple locations.',
    link: 'https://www.acdsystems.com',
    tags: [{ label: 'Python', color: 'hsl(75, 100%, 40%)' }],
  },
];
